import { gsap } from "gsap";
export default class SectorsList{
    
    constructor(element) {
        this._wrapper = element;
        this._btns = this._wrapper.querySelectorAll('.js-sectors-list-btn');
        this._contents = this._wrapper.querySelectorAll('.js-sectors-list-content');
        
        this.bindEvents();
        this.checkUrlParams();
    }
    
    bindEvents(){
        app.nodesEventListener('click', this._btns, (el,n,e) => {
            if(el.classList.contains('is-active')){
                this.reset();
            }
            else{
                let targetIndex = el.getAttribute('data-target');
                let _targetContent = this._wrapper.querySelector('.js-sectors-list-content[data-index="'+targetIndex+'"]');
                let _otherContents = this._wrapper.querySelectorAll('.js-sectors-list-content:not([data-index="'+targetIndex+'"])');

                let _targetBtns = this._wrapper.querySelectorAll('.js-sectors-list-btn[data-target="'+targetIndex+'"]');
                let _otherBtns = this._wrapper.querySelectorAll('.js-sectors-list-btn:not([data-target="'+targetIndex+'"])');

                app.nodesAddClass(_targetBtns,'is-active');
                app.nodesRemoveClass(_otherBtns,'is-active');
                this.filterContents(_targetContent, _otherContents);
            }
        });
    }
    
    checkUrlParams(){
        let params = new URLSearchParams(document.location.search);
        if(params.get('target')){
            let targetIndex = params.get('target');
            let _targetContent = this._wrapper.querySelector('.js-sectors-list-content[data-index="'+targetIndex+'"]');
            let _otherContents = this._wrapper.querySelectorAll('.js-sectors-list-content:not([data-index="'+targetIndex+'"])');

            let _targetBtns = this._wrapper.querySelectorAll('.js-sectors-list-btn[data-target="'+targetIndex+'"]');
            let _otherBtns = this._wrapper.querySelectorAll('.js-sectors-list-btn:not([data-target="'+targetIndex+'"])');
            if(_targetContent){
                app.nodesAddClass(_targetBtns,'is-active');
                app.nodesRemoveClass(_otherBtns,'is-active');
                this.filterContents(_targetContent, _otherContents);
            }
        }
    }
    
    filterContents(_targetContent, _otherContents){
        gsap.to(_otherContents, {y:'-50px', alpha:0, onComplete:() => {
                app.nodesAddClass(_otherContents, 'd-none');
                _targetContent.classList.remove('d-none');
                _targetContent.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                gsap.to(_targetContent, {y:'0px', alpha:1});
            }
        });
    }
    
    reset(){
        app.nodesRemoveClass(this._btns, 'is-active');
        app.nodesRemoveClass(this._contents, 'd-none');
        
        gsap.to(this._contents,  {y:'0px', alpha:1});
    }
    
}